import { SupportingHref, fieldSchema, selectedId } from './FieldsWidget.constants';
import { IFieldObject, IFieldResult } from './FieldsWidget.properties';

export const getKeyId = (props) => {
  const module = location.pathname.split('/').filter(Boolean)?.[0];

  return (props[selectedId?.[module]]);
};

export const urlConstructor = (link: string, props) => {
  switch (link) {
    case 'price-check':
      const params = new URLSearchParams();
      params.set('ProductId', props?.selectedProduct);
      params.set('WarehouseEntity', props?.defaultWarehouseEntity);
      params.set('SalesEntity', props?.defaultSalesEntity);
      params.set('SalesQuantity', '1');

      return `/${link}?${params.toString()}`;
    default:
      return '';
  }
};

export const getFieldValues = (obj: IFieldObject): IFieldResult[] => {
  const rightAlignedTypes = ['integer', 'decimal', 'int64'];

  return fieldSchema
    .map(({ type, sequence }): IFieldResult | null => {
      const fieldValue = obj[type]?.Value;
      if (fieldValue === '' || fieldValue === undefined || fieldValue === null) return null;

      if (obj.FieldDataType.Value === 'button') {
        return {
          sequence,
          alignment: 'center',
          type: 'Button',
          link: obj?.Link?.Value,
          label: obj?.FieldName?.Value
        };
      }

      const alignment: 'left' | 'right' = rightAlignedTypes.includes(obj.FieldDataType?.Value) ? 'right' : 'left';

      return {
        value: fieldValue,
        type,
        color: obj.Colour?.Value,
        sequence,
        alignment
      };
    })
    .filter((field): field is IFieldResult => field !== null)
    .sort((a, b) => a.sequence - b.sequence);
};

export const normalizeUrl = (url: string) => {
  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    return `https://${url}`;
  }

  return url;
};

export const generateAnchorProps = (type: string, value: string) => {
  const supportingHref = SupportingHref?.[type];

  if (!supportingHref) return { href: normalizeUrl(value), target: '_blank' };

  return { href: `${SupportingHref?.[type]}:${value}` };
};
